import css from '@emotion/css';
import styled from '@emotion/styled';
import { Paper } from '@mui/material';
import theme from '../../theme';
import SelectionCardProps from './selection-card.interfaces';

const iconColor = '#333336';

const sizeStyles = {
  medium: css`
    min-height: ${theme.spacing((2 / 3) * 20)};
    width: ${theme.spacing(20)};
  `,
  large: css`
    min-height: ${theme.spacing((2 / 3) * 30)};
    width: ${theme.spacing(30)};
  `,
};

const paperDisabledStyles = css`
  cursor: default;
  svg {
    opacity: 0.4;
  }
`;

export const Card = styled(Paper)`
  display: inline-block;
  cursor: pointer;
  padding: ${theme.spacing(2)};
  border: 1px solid ${theme.palette.border.secondary};
  ${({ size }: SelectionCardProps) => sizeStyles[size]}
  ${({ disabled }: SelectionCardProps) => (disabled && paperDisabledStyles) || ''}
`;

export const IconContainer = styled('div')`
  svg {
    position: relative;
    display: block;
    margin: ${theme.spacing(1)} auto;
    width: ${theme.spacing(5)};
    height: ${theme.spacing(5)};
    fill: ${iconColor};
    opacity: ${({ disabled }: SelectionCardProps) => (disabled && '0.4') || '1'};
  }
`;

export const BodyContainer = styled('div')`
  opacity: ${({ disabled }: SelectionCardProps) => (disabled && '0.4') || '1'};
`;
